import { orderAutomatizationSelectors } from '@/ModalWindows/OrderAutomatizationModal/services/selectors';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export const useContractLogisticOptions = (
  orderId: number,
  selectedPackages: { key: string; weight: string | number }[],
  isOwnContract: boolean,
) => {
  const orderPackages = useSelector(orderAutomatizationSelectors.orderPackages);

  const { packageOptions, isContractsConfigured } = useMemo(() => {
    const currentOrderPackages = orderPackages.find((op) => {
      return op.orderId === orderId && op.isOwnContract == isOwnContract;
    });

    return {
      isContractsConfigured: currentOrderPackages?.isContractsConfigured,
      packageOptions: currentOrderPackages?.packages,
    };
  }, [orderId, orderPackages, isOwnContract]);

  const productOptions = useMemo(() => {
    if (!packageOptions || selectedPackages.length === 0) return [];

    const selectedPackageKeys = selectedPackages.map((p) => p.key);
    const selectedPackageOptions = packageOptions.filter((p) => {
      return selectedPackageKeys.includes(p.key);
    });

    if (selectedPackageOptions.length === 0) return [];

    const firstPackageProducts = selectedPackageOptions[0].products;

    return firstPackageProducts.filter((product) =>
      selectedPackageOptions.every((pkg) => {
        return pkg.products.some((p) => p.id === product.id);
      }),
    );
  }, [packageOptions, selectedPackages]);

  return {
    packageOptions,
    productOptions,
    isContractsConfigured,
  };
};
